require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-financial-center-donates-usd-10-000-to-the-indiana-military-veterans-hall-of.json") })
        }
      }, "path---articles-financial-center-donates-usd-10-000-to-the-indiana-military-veterans-hall-of");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-financial-center-donates-usd-10-000-to-the-indiana-military-veterans-hall-of!./.cache/json/articles-financial-center-donates-usd-10-000-to-the-indiana-military-veterans-hall-of.json
// module id = 1606
// module chunks = 231608221292675